import { SearchScenarioId } from 'owa-search-next';

/**
 * This is a helper function to determine if a received action was meant for the
 * search box in the mail module by comparing the scenarioId (that comes with each
 * action from shared search packages) and comparing it to the mail module's
 * designated value.
 */
export default function isMailSearchAction(scenarioId: SearchScenarioId): boolean {
    return scenarioId === SearchScenarioId.Mail;
}
